import Link from 'next/link'
import { useForm } from 'react-hook-form'
import Button from '@/src/components/button'
import React from 'react'
import { businessSignUpSchema } from '@/src/types'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormTextField, PasswordField } from '@/src/components/form-components'
import { TextField, Typography } from '@mui/material'

interface FormData {
  firstName: string
  lastName: string
  email: string
  password: string
}

export interface Props {
  defaultEmail: string
  loading: boolean
  onSubmit: (formData: FormData) => void
}
const CreateAccountForm = ({ loading, onSubmit, defaultEmail }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(businessSignUpSchema),

    defaultValues: {
      firstName: '',
      lastName: '',
      email: defaultEmail.replaceAll(' ', '+'),
      password: ''
    }
  })

  const formSubmit = (data: FormData) => {
    onSubmit(data)
  }

  return (
    <div>
      <form
        className="grid grid-cols-2  gap-2 sm:gap-4 px-3 max-sm:px-0"
        onSubmit={handleSubmit(formSubmit)}
      >
        <TextField
          id="signup-email"
          label={'Email Address'}
          {...register('email')}
          variant="outlined"
          autoComplete="off"
          placeholder={'Email Address'}
          className="col-span-full"
          error={!!errors.email}
          helperText={errors.email?.message}
          fullWidth
          InputProps={{
            className: `rounded-[0.625rem] border-icon-darkgray `
          }}
          InputLabelProps={{
            className: 'text-secondary-main'
          }}
        />

        <FormTextField
          label="First Name"
          placeholder="First Name"
          divClass="col-span-full sm:col-span-1"
          validation={register('firstName')}
          error={!!errors.firstName}
          helperText={errors?.firstName?.message}
          InputLabelProps={{
            className: 'text-secondary-main'
          }}
        />
        <FormTextField
          label="Last Name"
          placeholder="Last Name"
          divClass="col-span-full sm:col-span-1"
          validation={register('lastName')}
          error={!!errors.lastName}
          helperText={errors?.lastName?.message}
          InputLabelProps={{
            className: 'text-secondary-main'
          }}
        />
        <PasswordField
          passwordKey="register"
          id="signup-password"
          label="Password"
          placeholder="Password"
          divClass="col-span-full"
          validation={register('password')}
          error={!!errors.password}
          helperText={errors.password?.message}
          InputLabelProps={{
            className: 'text-secondary-main'
          }}
        />
        <Typography
          variant="inputHelper"
          color="text.secondary"
          className="col-span-full font-normal -m-3 pl-3 max-sm:mx-0 max-sm:mt-2 max-sm:mb-4 max-sm:pl-0"
        >
          Create a strong password with a mix of letters, numbers & symbols.{' '}
        </Typography>

        <div className="col-span-full">
          <Button
            text="Create account"
            type="submit"
            onClick={() => {}}
            fullwidth={true}
            loading={loading}
            extraClass="normal-case"
          />
        </div>
      </form>
      <div className="flex items-center w-full pt-3 sm:pt-2  pl-3 max-sm:pl-0 justify-start gap-x-2">
        <Typography variant="body2" color="text.secondary">
          Already have an account?{' '}
        </Typography>
        <Link className="text-center" href="/login?redirect_url=__widget_login__">
          <Typography variant="tableHeader" color="primary.main" className="!leading-[1.225rem]">
            Log in
          </Typography>
        </Link>
      </div>
    </div>
  )
}

export default CreateAccountForm
